import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { useLocation } from 'react-router';
import useMounted from '../../../hooks/useMounted';
import { useCallback, useEffect, useState } from 'react';
import { usersApi } from '../../../api/usersApi';
import PhotoUploadDialog from './PhotoUploadDialog';
import useAuth from '../../../hooks/useAuth';

const UserFunctionSettings = (props) => {
  const path = useLocation();
  const { user } = useAuth();
  const routeUserId = path.pathname.split('/')[3];
  const effectiveUserId = props.userId || routeUserId || (user ? user.id : null);
  const [userToUpdate, setUserToUpdate] = useState({});
  const [photoDialogOpen, setPhotoDialogOpen] = useState(false);
  const mounted = useMounted();

  const getUserInfos = useCallback(async () => {
    try {
      if (!effectiveUserId) return;
      const data = await usersApi.getUserInfos(window.localStorage.getItem('accessToken'), effectiveUserId);
      if (mounted.current) {
        setUserToUpdate(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, effectiveUserId]);

  const handleChange = (field) => (event) => {
    setUserToUpdate(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  useEffect(() => {
    getUserInfos();
  }, [getUserInfos]);

  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{ mt: 1 }}
        {...props}
      >
        <Grid
          item
          lg={4}
          md={6}
          xl={3}
          xs={12}
        >
          <Card>
            <CardContent>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center'
                }}
              >
                <Box
                  sx={{
                    p: 1,
                    border: (theme) => `1px dashed ${theme.palette.divider}`,
                    borderRadius: '50%'
                  }}
                >
                  <Avatar
                    src={userToUpdate.photo ? `data:image/jpeg;base64,${userToUpdate.photo}` : ''}
                    sx={{
                      height: 140,
                      width: 140
                    }}
                  />
                </Box>
                <Typography
                  color="textPrimary"
                  sx={{ mt: 1 }}
                  variant="subtitle2"
                >
                  {userToUpdate.firstname}
                  {' '}
                  {userToUpdate.lastname}
                </Typography>
                <Typography
                  color="textSecondary"
                  variant="body2"
                >
                  {userToUpdate.functions}
                </Typography>
              </Box>
            </CardContent>
            <CardActions>
              <Button
                color="primary"
                fullWidth
                variant="text"
                onClick={() => setPhotoDialogOpen(true)}
              >
                Changer de photo
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid
          item
          lg={8}
          md={6}
          xl={9}
          xs={12}
        >
          <Card>
            <CardHeader title="Fonction" />
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={4}
              >
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Fonction"
                    value={userToUpdate.functions || ''}
                    onChange={handleChange('functions')}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Niveau d'accès</InputLabel>
                    <Select
                      value={userToUpdate.access_level || ''}
                      onChange={handleChange('access_level')}
                      label="Niveau d'accès"
                    >
                      <MenuItem value={0}>Fort (0)</MenuItem>
                      <MenuItem value={1}>Faible (1)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                >
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Service</InputLabel>
                    <Select
                      value={userToUpdate.id_service || ''}
                      onChange={handleChange('id_service')}
                      label="Service"
                    >
                      <MenuItem value={0}>Administrateur (0)</MenuItem>
                      <MenuItem value={3}>Commercial (3)</MenuItem>
                      <MenuItem value={4}>Relance (4)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={async () => {
                  try {
                    const updateData = {
                      functions: userToUpdate.functions,
                      access_level: parseInt(userToUpdate.access_level),
                      id_service: parseInt(userToUpdate.id_service)
                    };
                    if (!effectiveUserId) return;
                    await usersApi.updateUserFunction(window.localStorage.getItem('accessToken'), updateData, effectiveUserId);
                    toast.success('Fonction mise à jour !');
                  } catch (err) {
                    console.error(err);
                    toast.error('Erreur lors de la mise à jour');
                  }
                }}
              >
                Enregistrer les modifications
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>

      <PhotoUploadDialog
        open={photoDialogOpen}
        onClose={() => setPhotoDialogOpen(false)}
        onPhotoUploaded={(photoData) => {
          setUserToUpdate(prev => ({
            ...prev,
            photo: photoData.split(',')[1] // Enlever le préfixe data:image/...
          }));
        }}
        currentPhoto={userToUpdate.photo ? `data:image/jpeg;base64,${userToUpdate.photo}` : ''}
        userId={effectiveUserId}
      />
    </>
  );
};

export default UserFunctionSettings;
